<template>
  <div>
    <ul class="flex bg-[#2B2C32] rounded-full py-1 mb-2">

      <li :class="'mr-4' + (activeTab == 'Profile' ? ' active' : '')">
        <router-link :to="{ name: 'SettingGeneralProfile' }" href="#" class="inline-block text-theme-white tracking-widest text-sm font-semibold px-2 uppercase">
          Profiles
        </router-link>

      </li>
      <!-- <li :class="activeTab == 'BusinessSettings' ? ' active' : ''">
        <router-link :to="{ name: 'SettingGeneralBusiness' }" href="#" class="inline-block text-theme-white tracking-widest text-sm font-semibold px-2 uppercase">
          Business Settings
        </router-link>
      </li> -->
    </ul>
  </div>
</template>

<script lang="ts">
  import {
    defineComponent
  } from "vue"

  export default defineComponent({
    name: "Nav",
    props: {
      activeTab: {
        type: String,
        required: true
      },
      changeTab: {
        type: Function,
        required: true
      }
    }
  })
</script>


<style scoped>
  .active:before {
    content: '';
    position: absolute;
    background: #2BA66B;
    width: 100%;
    height: 4px;
    bottom: -8px;
  }

  .active {
    position: relative;
  }
</style>